import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import { WIDGET_API } from 'utils/constants';

import type { PayHubCashierContractsCashierBrowserDataRequest } from '../models';

export interface GenerateOTPResponse {
  status: 'success' | 'fail';
  error?: string;
  error_code?: string;
  errorCode?: string;
  error_message?: string;
  errorMessage?: string;
  can_resend?: boolean;
  canResend?: boolean;
}

export interface GenerateOTPRequest {
  paygroup_id?: number | null;
  amount: number;
  currency: string;
  parameters: {
    [p: string]: string;
  };
  browser_data?: PayHubCashierContractsCashierBrowserDataRequest;
}

export const otpAPI = createApi({
  reducerPath: 'otpAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      generateOTP: builder.mutation<GenerateOTPResponse, GenerateOTPRequest>({
        query: (body) => ({
          url: `payments/groups/${body.paygroup_id}/otp`,
          method: 'POST',
          body: {
            ...body,
            paygroup_id: undefined,
          },
        }),
        transformResponse: (response: GenerateOTPResponse): GenerateOTPResponse => ({
          status: response.status,
          error: response.error,
          canResend: response.can_resend,
          errorCode: response?.error_code,
          errorMessage: response?.error_message,
        }),
      }),
    };
  },
});

export const { useGenerateOTPMutation } = otpAPI;
export default otpAPI.reducer;
